module.exports = __webpack_public_path__ + "img/background-tvroom-pc.7e05ca1c.jpg";